// Styles
import './collections-list.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCollectionsList = (context) => {
  const collectionsListSection = context.closest('.shopify-section');
}

if(document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.collections-list'), (el) => {
    window.dAgency.initCollectionsList(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.collections-list'), (el) => {
      window.dAgency.initCollectionsList(el);
    });
  });
}
